import { useCallback } from 'react';

import { usePutCollectionFundingInstructionsAccountNumberAcceptChanges } from 'api';

import { usePermissions } from 'hooks/usePermissions';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

type Props = {
  organisationId: number;
  accountNumber: number;
  configurationUuid: string;
  onAccepted: () => void;
};

export const FundingChangesNotice = ({
  organisationId,
  accountNumber,
  configurationUuid,
  onAccepted
}: Props) => {
  const { isPermitted } = usePermissions();
  const canAcceptChanges = isPermitted('accounts:accept_funding_update');
  const mutation =
    usePutCollectionFundingInstructionsAccountNumberAcceptChanges();

  const handleAccept = useCallback(async () => {
    await mutation.mutateAsync({
      organisationId: organisationId,
      accountNumber: accountNumber,
      data: { configuration_uuid: configurationUuid }
    });

    onAccepted();
  }, [mutation, organisationId, accountNumber, configurationUuid, onAccepted]);

  return (
    <div className="flex flex-col gap-2 rounded-2xl bg-status-action-required p-4">
      <div className="font-semibold">Funding updated</div>

      <div className="flex items-start justify-between gap-8">
        {canAcceptChanges ? (
          <>
            <div className="text-sm">
              Please make sure that all members of your organisation are aware
              of the new payment instructions.
            </div>

            <PrimaryButton onClick={handleAccept} disabled={mutation.isPending}>
              I got it!
            </PrimaryButton>
          </>
        ) : (
          <div className="text-sm">
            The payment instructions for this account have changed. Use the
            details below for your next transfer.
          </div>
        )}
      </div>
    </div>
  );
};
